import { Field, Form, Formik } from "formik"
import { useNavigate } from "react-router-dom"
import { verifyOtpSchema } from "./schema"
import { useVerifyOTP } from "../../hooks/useTwoFa"
import { useLogout } from "../../hooks/useAuth"
import routePaths from "../../constants/path"
import TextField from "../../components/TextField"
import ApiError from "../../components/ApiError"

const VerifyOtpForTwoFa = () => {
  const navigate = useNavigate()
  const {
    isPending: verifyingOTP,
    mutate: verifyOTP,
    error: verifyOTPError,
    isError: isVerifyOTPError,
  } = useVerifyOTP()
  const { mutate: logout } = useLogout()

  const handleSubmit = (values) => {
    verifyOTP({ otp: values.otp, rememberMe: !!values.rememberMe })
  }

  const handleBackToLogin = () => {
    logout(undefined, {
      onSettled: () => {
        navigate(routePaths.login, { replace: true })
      },
    })
  }

  return (
    <div className="flex flex-col gap-3 mt-4 w-96 mx-auto px-10 py-8 bg-white rounded-lg">
      <h3 className="text-center text-xl font-bold">
        Two-Factor Authentication
      </h3>
      <Formik
        enableReinitialize
        initialValues={{ otp: "", rememberMe: true }}
        validationSchema={verifyOtpSchema}
        onSubmit={handleSubmit}
      >
        <Form className="flex flex-col gap-6">
          <TextField
            autofocus={true}
            label="Authentication Code"
            name="otp"
            placeholder="Enter 6-digit code"
          />
          {isVerifyOTPError && <ApiError axiosError={verifyOTPError} />}
          <div className="flex ml-2 gap-2">
            <Field id="rememberMe" name="rememberMe" type="checkbox" />
            <label className="text-sm" htmlFor="rememberMe">
              Remember this device
            </label>
          </div>
          <button
            className="w-full bg-secondary hover:bg-secondary_dark text-white px-6 py-2 rounded-lg disabled:bg-gray-400"
            disabled={verifyingOTP}
            type="submit"
          >
            Verify
          </button>
        </Form>
      </Formik>
      <div className="mt-4 w-full flex flex-col gap-3">
        <p>
          Open your two-factor authenticator app to view your authentication
          code.
        </p>
        <button
          className="text-secondary underline text-center"
          onClick={handleBackToLogin}
        >
          Back to Login
        </button>
      </div>
    </div>
  )
}

export default VerifyOtpForTwoFa
